export default "<app-sent-to-ipx-list></app-sent-to-ipx-list>"